import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';
import SortableTableCell from '@eogile/agrements-common/src/components/table/SortableTableCell';
import { PaginationAndSortCommand } from '@eogile/agrements-common/src/components/table/tableTypes';
import { MinistryUsersSortableFields } from '../ministryUsersTypes';

type Props = {
  onCommandChange: (newCommand: PaginationAndSortCommand<MinistryUsersSortableFields>) => void;
  command: PaginationAndSortCommand<MinistryUsersSortableFields>;
};

const MinistryUsersTableHeader = ({ onCommandChange, command }: Props) => {
  return (
    <TableHead>
      <TableRow>
        <SortableTableCell<MinistryUsersSortableFields>
          label="Login"
          sortField="LOGIN"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<MinistryUsersSortableFields>
          label="Nom"
          sortField="LAST_NAME"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<MinistryUsersSortableFields>
          label="Prénom"
          sortField="FIRST_NAME"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<MinistryUsersSortableFields>
          label="Email"
          sortField="EMAIL"
          onChange={onCommandChange}
          command={command}
        />
        <SortableTableCell<MinistryUsersSortableFields>
          label="Zone territoriale"
          sortField="TERRITORIAL_AREA"
          onChange={onCommandChange}
          command={command}
        />
        <TableCell>Rôles</TableCell>
        <TableCell>Statut</TableCell>
        <SortableTableCell<MinistryUsersSortableFields>
          label="Date maj"
          sortField="UPDATED_AT"
          onChange={onCommandChange}
          command={command}
        />
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default MinistryUsersTableHeader;
